CheckoutV2.PaymentV2.PriorAuth = function(checkout, $container) {
    var method = this;

    this.cartBalance = parseFloat(checkout.cart.totals.values.total);
    this.data = {
        authNum: null,
        cardType: null,
        amtInput: null
    };

    this.validationTimeout = null;

    this.$feedback = null;
    this.$info = null;

    this._init = function() {
        checkout.cart.totals.registerTotalChangedListener(method._onTotalsChanged);

        method._render();
        method._listen();
        method.setNextStepButtonHtml();
        checkout.payment.onMethodInvalid();
        method._setPaymentActiveMethods();
    };

    this._listen = function() {
        $container.find('input.payment-method-priorauth-num').on('input', function(e){
            var authNumber = $(this).val();

            clearTimeout(method.validationTimeout);

            method.validationTimeout = setTimeout(function(){
                method._validateAuthNumber(authNumber);
            }, 300);
        });
    };

    this._render = function() {
        var $content = $($.parseHTML(Jemplate.process('includes/partials/payment/priorAuth.html')));
        $container.find('.payment-method-priorauth-container').html($content);

        method.$feedback = $container.find('.js-form-feedback');
        method.$info = $container.find('.js-priorauth-order');

        $container.find('.collapse').addClass('show');
    };

    this._validateAuthNumber = function(authNumber) {

        $container.find('.js-form-loading').removeClass('hidden');

        $.ajax({
            url: '/Validate/AuthorizationNumber/'+authNumber+'/',
            method: 'GET',
            dataType: 'json'
        })
            .done(function(response) {
                // Paypal prior auths cannot be used unless the existing balance on the auth is >= the cart total
                if(response.method === 'paypal' && parseFloat(response.balance) < method.cartBalance) {
                    method.$feedback.find('span').html('Paypal balance does not cover the order total. Authorized Balance: ' + response.balance);
                    method.$feedback.show();
                    checkout.payment.onMethodInvalid();
                    return;
                }

                method._setDataFromResponse(response, authNumber);
                method._renderAuthInfo();
                method._setPaymentActiveMethods(checkout.cart.totals.values.total);
                checkout.payment.onMethodValid();
            })
            .fail(function(error) {
                if(error.status === 404 && error.responseJSON){
                    method.$feedback.find('span').html(error.responseJSON.message);
                }
                else {
                    method.$feedback.find('span').html("An error occurred, could not validate authorization.");
                }
                method.$info.html("");
                method.$feedback.show();
                checkout.payment.onMethodInvalid();
            })
            .always(function() {
                $container.find('.js-form-loading').addClass('hidden');
            });
    };

    this._setDataFromResponse = function(response, authNumber) {
        if(response.method === 'paypal') {
            method.data.cardType = 'paypal';
            method.data.amtInput = response.balance;
        } else {
            method.data.cardType = response.cardType;
            method.data.amtInput = method.cartBalance;
        }
        method.data.authNum = authNumber;
    };

    this._renderAuthInfo = function() {

        method.$info.html("");
        method.$info.append('<div> Balance:: ' + method.data.amtInput +'</div>');
        method.$info.append('<div> Type:: ' + method.data.cardType +'</div>');

        method.$feedback.find('span').html("");
        method.$feedback.hide();
    };

    this._onTotalsChanged = function(oldTotals) {
        // Bail if the amount input has not been set, it means we don't have an auth number
        // and thus nothing to update yet
        if(!method.data.amtInput) {
            return
        }

        var currentCartRemaining = __fixDecimals(checkout.cart.totals.values.remaining);
        // paypal needs some special treatment. Signal error if the updated remaining amount
        // busts the paypal approved amount
        if(method.data.cardType === 'paypal'){
            if(method.data.amtInput < currentCartRemaining) {
                method.$feedback.find('span').html('Paypal balance does not cover the order total. Authorized Balance: ' + method.data.amtInput.toMoney());
                method.$feedback.show();
                checkout.payment.onMethodInvalid();
            }
        } else { // otherwise we update the input and render the balance info
            method.data.amtInput = currentCartRemaining;
            method._renderAuthInfo();
            checkout.payment.onMethodValid();
        }
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(amount){
        var paymentMethod = checkout.payment.models.paymentMethodFromPriorAuth(amount, method.data, checkout.billinfo.getData().billing);
        checkout.payment.setActivePaymentMethods([paymentMethod]);
    };

    // Called by checkout and the method to set the next step button text
    this.setNextStepButtonHtml = function() {
        checkout.payment.setNextStepCTA(checkout.getReviewStepCTA());
        checkout.payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
    };

    this.destroy = function() {
        // Unbind module event listeners
        checkout.cart.totals.removeTotalChangedListener(method._onTotalsChanged);
    };

    this._init();
};